// Module
var code = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect x=\"0.5\" y=\"0.5\" width=\"17\" height=\"17\" rx=\"5.5\" fill=\"#242424\" stroke=\"rgba(255, 255, 255, 0.5)\"/> </svg> ";
// Exports
module.exports = code;